<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    class="material-design-icon account-icon"
    role="img"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <svg
      :fill="props.fillColor"
      class="material-design-icon__svg"
      :width="props.size"
      :height="props.size"
      viewBox="0 0 24 24"
    >
      <path
        d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2 C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z"
      >
        <title>{{ props.title }}</title>
      </path>
    </svg>
  </span>
</template>

<script>
/* Fonte do SVG: https://icons8.com/icons/set/f-do-facebook */
export default {
  name: 'FacebookIcon',
  props: {
    title: {
      type: String,
      default: 'Facebook icon',
    },
    decorative: {
      type: Boolean,
      default: false,
    },
    fillColor: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
